import { inject } from 'vue';

export function getZiggyRoute() {
    const globalRoute = globalThis.window?.route ?? globalThis.route;

    if (typeof globalRoute !== 'function') {
        throw new Error('Ziggy route helper is not available.');
    }

    return globalRoute;
}

export function useZiggyRoute() {
    const injectedRoute = inject('route', null);

    if (typeof injectedRoute === 'function') {
        return injectedRoute;
    }

    return getZiggyRoute();
}
